import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

const initialState = {
  movie_genres: [],
  movie_genres_loading: false,
  movie_genres_error: null,

  tv_show_genres: [],
  tv_show_genres_loading: false,
  tv_show_genres_error: null,

  movie_tags: [],
  movie_tags_loading: false,
  movie_tags_error: null,

  tv_show_tags: [],
  tv_show_tags_loading: false,
  tv_show_tags_error: null,

  movie_years: [],
  movie_years_loading: false,
  movie_years_error: null,

  tv_show_years: [],
  tv_show_years_loading: false,
  tv_show_years_error: null,

};

export const fetchMovieGenres = createAsyncThunk(
  "catalog/fetchMovieGenres",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.MOVIE_GENRES);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTvShowGenres = createAsyncThunk(
  "catalog/fetchTvShowGenres",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TV_SHOW_GENRES);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchMovieTags = createAsyncThunk(
  "catalog/fetchMovieTags",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.MOVIE_TAGS);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTvShowTags = createAsyncThunk(
  "catalog/fetchTvShowTags",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TV_SHOW_TAGS);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchMovieYears = createAsyncThunk(
  "catalog/fetchMovieYears",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.MOVIE_YEARS);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTvShowYears = createAsyncThunk(
  "catalog/fetchTvShowYears",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TV_SHOW_YEARS);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const catalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
    setGenreTab: (state, action) => {
      state.active_genre_tab = action.payload;
    },
    setTagTab: (state, action) => {
      state.active_tag_tab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovieGenres.pending, (state) => { state.movie_genres_loading = true; })
      .addCase(fetchMovieGenres.fulfilled, (state, action) => { state.movie_genres_loading = false; state.movie_genres = action.payload; })
      .addCase(fetchMovieGenres.rejected, (state, action) => { state.movie_genres_loading = false; state.movie_genres_error = action.payload; })

      .addCase(fetchTvShowGenres.pending, (state) => { state.tv_show_genres_loading = true; })
      .addCase(fetchTvShowGenres.fulfilled, (state, action) => { state.tv_show_genres_loading = false; state.tv_show_genres = action.payload; })
      .addCase(fetchTvShowGenres.rejected, (state, action) => { state.tv_show_genres_loading = false; state.tv_show_genres_error = action.payload; })

      .addCase(fetchMovieTags.pending, (state) => { state.movie_tags_loading = true; })
      .addCase(fetchMovieTags.fulfilled, (state, action) => { state.movie_tags_loading = false; state.movie_tags = action.payload; })
      .addCase(fetchMovieTags.rejected, (state, action) => { state.movie_tags_loading = false; state.movie_tags_error = action.payload; })

      .addCase(fetchTvShowTags.pending, (state) => { state.tv_show_tags_loading = true; })
      .addCase(fetchTvShowTags.fulfilled, (state, action) => { state.tv_show_tags_loading = false; state.tv_show_tags = action.payload; })
      .addCase(fetchTvShowTags.rejected, (state, action) => { state.tv_show_tags_loading = false; state.tv_show_tags_error = action.payload; })

      .addCase(fetchMovieYears.pending, (state) => { state.movie_years_loading = true; })
      .addCase(fetchMovieYears.fulfilled, (state, action) => { state.movie_years_loading = false; state.movie_years = action.payload; })
      .addCase(fetchMovieYears.rejected, (state, action) => { state.movie_years_loading = false; state.movie_years_error = action.payload; })

      .addCase(fetchTvShowYears.pending, (state) => { state.tv_show_years_loading = true; })
      .addCase(fetchTvShowYears.fulfilled, (state, action) => { state.tv_show_years_loading = false; state.tv_show_years = action.payload; })
      .addCase(fetchTvShowYears.rejected, (state, action) => { state.tv_show_years_loading = false; state.tv_show_years_error = action.payload; });
  },
});

export const { setGenreTab, setTagTab } = catalogSlice.actions;
export default catalogSlice.reducer;
